<form [formGroup]="bastidorForm" class="form-section">
  <!-- Grupo: Vehículo -->
  <h6 class="form-group-label">{{ "bastidores.group_vehicle" | translate }}</h6>
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="vin" class="form-label">{{ "bastidores.vin" | translate }}
          <span class="required" *ngIf="!isEditMode">*</span>
        </label>
        <input type="text" class="form-control" id="vin" formControlName="vin"
          placeholder="{{ 'bastidores.vin' | translate }}" />
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="license_plate" class="form-label">{{ "bastidores.license_plate" | translate }}</label>
        <input type="text" class="form-control" id="license_plate" formControlName="license_plate"
          placeholder="{{ 'bastidores.license_plate' | translate }}" />
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="colour" class="form-label">{{ "bastidores.colour" | translate }}</label>
        <input type="text" class="form-control" id="colour" formControlName="colour"
          placeholder="{{ 'bastidores.colour' | translate }}" maxlength="255" />
      </div>
    </div>
  </div>

  <!-- Grupo: Fabricante -->
  <h6 class="form-group-label">{{ "bastidores.group_manufacturer" | translate }}</h6>
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="supplier_reference" class="form-label">{{ "bastidores.supplier_reference" | translate }}</label>
        <input type="text" class="form-control" id="supplier_reference" formControlName="supplier_reference"
          placeholder="{{ 'bastidores.supplier_reference' | translate }}" maxlength="255" />
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="vehicle_discount_code" class="form-label">{{ "bastidores.vehicle_discount_code" | translate }}</label>
        <input type="text" class="form-control" id="vehicle_discount_code" formControlName="vehicle_discount_code"
          placeholder="{{ 'bastidores.vehicle_discount_code' | translate }}" maxlength="255" />
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="workshop_id" class="form-label">{{ "bastidores.workshop" | translate }}</label>
        <ng-select formControlName="workshop_id" [items]="ladata?.workshopData" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="manufacture_expected_date" class="form-label">{{ "bastidores.manufacture_expected_date" | translate }}</label>
        <mat-form-field appearance="fill">
          <input matInput [matDatepicker]="manufacturePicker" formControlName="manufacture_expected_date"
            placeholder="{{ 'bastidores.manufacture_expected_date' | translate }}" />
          <mat-datepicker-toggle matSuffix [for]="manufacturePicker"></mat-datepicker-toggle>
          <mat-datepicker #manufacturePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="dealership_id" class="form-label">{{ "inputs.dealership" | translate }}</label>
        <ng-select formControlName="dealership_id" [items]="ladata?.dealershipData" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
        </ng-select>
      </div>
    </div>
  </div>

  <!-- Grupo: Estado -->
  <h6 class="form-group-label">{{ "bastidores.group_status" | translate }}</h6>
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="state" class="form-label">{{ "bastidores.state" | translate }}</label>
        <div class="input-group">
          <select id="state" class="form-control" formControlName="state">
            <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
            <option value="factory">{{ "bastidores.state_factory" | translate }}</option>
            <option value="countryside">{{ "bastidores.state_countryside" | translate }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="external_state" class="form-label">{{ "bastidores.external_state" | translate }}</label>
        <input type="text" class="form-control" id="external_state" formControlName="external_state"
          placeholder="{{ 'bastidores.external_state' | translate }}" maxlength="255" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="mb-3">
        <label for="notes" class="form-label">{{ "bastidores.notes" | translate }}</label>
        <textarea class="form-control" id="notes" formControlName="notes" rows="3" style="resize:none"
          placeholder="{{ 'bastidores.notes' | translate }}"></textarea>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="button" class="btn btn-primary btn-primary-form" (click)="onSubmit()" [disabled]="bastidorForm.invalid">
        {{ (isEditMode ? "buttons.update" : "buttons.create") | translate }}
      </button>
    </div>
  </div>
</form>
